import { useRef } from "react";
import { Container, Navbar } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Link } from "react-router";
import Logo from '@gearghost/brand-assets/wordmark/dark.svg';
import ToolboxMark from '@gearghost/brand-assets/toolbox/dark.svg';
import useIsAuthenticated from '@/hooks/useAuth';
import { useHeaderHeight } from '@/hooks/useHeaderHeight';
import HeaderMenu from "./headerMenu";
import HeaderMenuPublic from "./HeaderMenuPublic";

const Header = () => {
  const isAuthenticated = useIsAuthenticated();
  const headerRef = useRef(null);
  // The support chat panel stops short of this header on a short window.
  useHeaderHeight(headerRef);

  return (
    <Navbar ref={headerRef} collapseOnSelect expand="lg" className="bg-primary">
      <Container fluid>
        {/*
          Two logos, swapped by CSS at the navbar mobile breakpoint: the full
          wordmark is ~160px wide and, alongside the icon cluster, overflows a
          phone viewport. On mobile we show the toolbox mark alone to reclaim
          that width. Rendering both (vs. a JS viewport check) keeps it pure CSS
          and avoids a flash on resize. See `.navbar-brand` in _navigation.scss.
        */}
        <Navbar.Brand as={Link} to="/">
          <Image src={Logo} width="160" alt="GearGhost" className="navBrandWordmark" />
          <Image src={ToolboxMark} alt="GearGhost" className="navBrandMark" />
        </Navbar.Brand>
        {isAuthenticated ? <HeaderMenu /> : <HeaderMenuPublic />}
      </Container>
    </Navbar>
  );
};

export default Header;
